import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonMethods } from '../../common-methods';
import { UserService } from '../../services/user.service';
import { UiService } from '../../ui.service';

@Injectable({
  providedIn: "root"
})

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private uiService: UiService,
    private userService: UserService
  ) { }

  //To take any user
  user: any
  role: string | null = CommonMethods.getItem("role");

  ngOnInit(): void {
    this.getProfile();
  }

  getProfile() {
    this.userService.getUser().subscribe({
      next: (data: any) => {
        this.user = data.payload[0];
        CommonMethods.setItem('CompanyNumber', this.user.mobile_number)
      }, error: (err) => {
        console.error("err:", err)
      }
    })
  }

  /**
   * To logout
   */
  logout() {
    CommonMethods.removeItem("auth");
    CommonMethods.removeItem("token");
    CommonMethods.removeItem("userId");
    CommonMethods.removeItem("role");
    CommonMethods.removeItem("uid");
    CommonMethods.removeItem("adminId");
    CommonMethods.removeItem("companyId");
    CommonMethods.removeItem("serviceCenterId");
    CommonMethods.removeItem("userId");
    this.uiService.loginValid.next(false);
    this.router.navigateByUrl('auth');

    this.toastr.success("Logged out safely!");
  }
}
